import { useAsyncExecutor } from "async-executor-hook";
import { Menu } from "primereact/menu";
import { Paginator } from "primereact/paginator";
import queryString from "query-string";
import { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { FormArray, useFormConfig } from "rectangular-forms";
import { getErrorValueResponse } from "../../common/error/Error";
import { generateSequentialArray } from "../../common/utils";

import IconEditUser from "../../images/icon_edit_user.svg";
import IconItem from "../../images/icon_item.svg";
import IconTrashUser from "../../images/icon_trash_user.svg";
import LoadingSpinner from "../../images/loading_gray.gif";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { ITEMS_PER_PAGE } from "../../utils/valueStaticConstants";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { FakeRow } from "../DocumentManagement/DocumentManagementSharedStyles";
import Modal from "../Modal/Modal";
import StandaloneMessage from "../StandaloneMessage/StandaloneMessage";
import {
  Button,
  Container1,
  DivMarginTop,
  DivTable,
  DivUserMenu,
  DivUserMenuLabel,
  VolanteId,
} from "./UsersManagementAdminStyles";

interface IUsersManagementAdminTableNew {
  userInfo: {};
  loadUsers: any;
  setDataUserEditAdmin: any;
  showEdit: any;
}
const UsersManagementAdminTableNew: FC<IUsersManagementAdminTableNew> = (
  props
) => {
  const { userInfo, loadUsers, setDataUserEditAdmin, showEdit } = props;
  const formConfig = useFormConfig({
    createForm: () => {
      const form = new FormArray([]);
      return form;
    },
  });
  const { loadSucceed } = formConfig;
  useEffect(() => {
    loadSucceed([]);
  }, [loadSucceed]);

  const auxiliaryArray = generateSequentialArray(ITEMS_PER_PAGE);

  const [showModalDelete, setShowModalDelete] = useState(false);

  const [dataUser, setDataUser] = useState<any>();
  const onClose = () => {
    setShowModalDelete(!showModalDelete);
  };

  const [showErrorModalDeleteUser, setShowErrorModalDeleteUser] =
    useState(false);
  const [errorMessageType, setErrorMessageType] = useState("");

  const deleteUser = useAsyncExecutor(
    async (params: any) => {
      const { dataUser } = params;
      return await networkBackendRequest(
        `/users/${dataUser.id}/`,
        HTTP_METHODS.DELETE
      );
    },
    {
      onSuccess: () => {
        setShowModalDeleteUserBackoffice(true);
        setShowModalDelete(false);
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        setErrorMessageType(errorMessage);
        setShowModalDelete(false);
        setShowErrorModalDeleteUser(true);
      },
    }
  );

  const rowsRef = useRef([]);
  const itemsTwo = (props) => {
    return [
      {
        label: "Delete",
        icon: "pi pi-times",
        template: function Edit(item, options) {
          return (
            <>
              <DivUserMenu
                marginTop="1.5rem"
                marginLeft="1.5rem"
                key={item}
                className={options.className}
                onClick={options.onClick}
              >
                <span>
                  <img src={IconEditUser} height="20px" width="20px" alt="" />
                </span>
                <DivUserMenuLabel
                  fontSize="1.4rem"
                  marginLeft="1.5rem"
                  fontWeight="600"
                >
                  Editar usuario
                </DivUserMenuLabel>
              </DivUserMenu>
            </>
          );
        },
        command: () => {
          setDataUserEditAdmin(props);
          setDataUser(props);
          showEdit();
        },
      },
      {
        label: "Delete",
        icon: "pi pi-times",
        template: function Save(item, options) {
          return (
            <>
              <DivUserMenu
                marginTop="1.5rem"
                marginLeft="1.5rem"
                marginBottom="1.5rem"
                key={item}
                className={options.className}
                onClick={options.onClick}
              >
                <span>
                  <img src={IconTrashUser} height="20px" width="20px" alt="" />
                </span>
                <DivUserMenuLabel
                  fontSize="1.4rem"
                  marginLeft="1.5rem"
                  fontWeight="600"
                >
                  Eliminar usuario
                </DivUserMenuLabel>
              </DivUserMenu>
            </>
          );
        },
        command: () => {
          setDataUser(props);
          onClose();
        },
      },
    ];
  };

  const [showModalDeleteUserBackoffice, setShowModalDeleteUserBackoffice] =
    useState(false);

  const history = useHistory();

  return (
    <div>
      <div>
        <DivTable>
          <table className="tableSearch tableSeparate table-margin-top">
            {loadUsers.isSuccess && loadUsers.data.users.length > 1 && (
              <thead>
                <tr className="between-flex">
                  <th className="width-flex-left">RAZÓN SOCIAL</th>
                  <th className="width-flex">USUARIO</th>
                  <th className="width-flex">CONTACTO</th>
                  <th className="width-flex">PERFIL</th>
                  <th className="flex-en-right">
                    <div style={{ width: 28, height: 25 }} />
                  </th>
                </tr>
              </thead>
            )}
            {loadUsers.isLoading &&
              auxiliaryArray.map((_, index) => {
                return <FakeRow key={index} />;
              })}
            {loadUsers.isSuccess &&
              loadUsers.data.users.map((data, i) => {
                return (
                  <tbody className="TableBody" key={data.id}>
                    <tr className="trBody between-flex-center">
                      <td className="width-left">
                        <VolanteId>
                          {data.company && data.company.ruc}
                        </VolanteId>
                        <div>{data.company && data.company.name}</div>
                      </td>
                      <td className="width-flex column-direction">
                        <VolanteId>{data.document_number}</VolanteId>
                        <div className="margin-top-2">{data.full_name}</div>
                        <div className="margin-color-2">{data.role.name}</div>
                      </td>
                      <td className="width-flex column-direction">
                        <VolanteId>{data.phone_number}</VolanteId>
                        <div className="margin-top-2">{data.email}</div>
                      </td>
                      <td className="width-flex font-weight-line">
                        <b>{data.role.profile.name}</b>
                      </td>
                      <td className=" flex-with-rem">
                        <div>
                          <Menu
                            style={{ width: "28.2rem", borderRadius: "8px" }}
                            model={itemsTwo({ ...data, userInfo })}
                            popup
                            ref={(elRef) => (rowsRef.current[i] = elRef)}
                            id="popup_menu_two"
                          />
                          <img
                            src={IconItem}
                            width="25px"
                            height="25px"
                            alt=""
                            onClick={(event) => {
                              rowsRef.current[i].toggle(event);
                            }}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                );
              })}
          </table>
        </DivTable>
        {loadUsers.isSuccess && loadUsers.data.users.length > 0 && (
          <DivMarginTop>
            <div>
              <Paginator
                first={(loadUsers.data.page - 1) * loadUsers.data.page_size}
                rows={loadUsers.data.page_size}
                totalRecords={loadUsers.data.count}
                onPageChange={(e) => {
                  const targetPage = e.first / loadUsers.data.page_size;
                  const queryParams = {
                    ...queryString.parse(window.location.search),
                    page: targetPage + 1,
                  };
                  const pathname = history.location.pathname;
                  history.push(
                    `${pathname}?${queryString.stringify(queryParams)}`
                  );
                }}
              />
            </div>
          </DivMarginTop>
        )}
        {loadUsers.isSuccess && loadUsers.data.users.length < 1 && (
          <StandaloneMessage>No se encontraron usuarios.</StandaloneMessage>
        )}
        {loadUsers.isError && (
          <div>
            Algo salió mal
            <button
              type="button"
              onClick={() => {
                loadUsers.retry();
              }}
            >
              Reintentar
            </button>
          </div>
        )}
        {showModalDelete && (
          <Modal onOutsideClick={onClose}>
            <Container1>
              <h1>Confirmación de eliminación</h1>
              <div className="description">
                <p>
                  ¿Estás seguro que deseas eliminar al usuario{" "}
                  <b>{dataUser && dataUser.full_name}</b>?
                </p>
              </div>
              <div className="button-container">
                <Button
                  status="confirm"
                  onClick={() => {
                    deleteUser.execute({ dataUser });
                  }}
                  disabled={deleteUser.isLoading}
                >
                  {deleteUser.isLoading && (
                    <img className="icon" src={LoadingSpinner} alt="spinner" />
                  )}
                  Eliminar usuario
                </Button>
                <Button status="cancel" onClick={onClose}>
                  Cancelar
                </Button>
              </div>
            </Container1>
          </Modal>
        )}
        {showErrorModalDeleteUser && (
          <ConfirmationModal
            message={errorMessageType}
            onAccept={() => {
              setErrorMessageType("");
              setShowErrorModalDeleteUser(false);
            }}
            title={`Atención`}
            toggleModal={() => {
              setErrorMessageType("");
              setShowErrorModalDeleteUser(false);
            }}
          />
        )}
      </div>
      {showModalDeleteUserBackoffice && (
        <ConfirmationModal
          message={`El usuario ${dataUser.full_name} ha sido eliminado exitosamente`}
          onAccept={() => {
            setShowModalDeleteUserBackoffice(false);
            const params = { ...loadUsers.getExecution().params, page: 1 };
            loadUsers.execute(params);
          }}
          title={`Usuario eliminado exitosamente`}
          toggleModal={() => {
            setShowModalDeleteUserBackoffice(false);
            const params = { ...loadUsers.getExecution().params, page: 1 };
            loadUsers.execute(params);
          }}
        />
      )}
    </div>
  );
};
export default UsersManagementAdminTableNew;
